export const VIEW_MODE = Object.freeze({
  TABLE: 'table',
  CARDS: 'cards',
})

export const VIEWPORT_CLASS = Object.freeze({
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
})

export const VIEW_MODE_BREAKPOINT = 768

const VALID_MODES = new Set(Object.values(VIEW_MODE))

export const getViewportClass = (width) => (
  Number(width) < VIEW_MODE_BREAKPOINT
    ? VIEWPORT_CLASS.MOBILE
    : VIEWPORT_CLASS.DESKTOP
)

export const getViewPreferenceKey = (family, viewportClass) => (
  `talent-service:view-mode:${encodeURIComponent(family)}:${viewportClass}`
)

export const readViewPreference = ({ family, viewportClass, storage }) => {
  if (!storage) return null
  try {
    const mode = storage.getItem(getViewPreferenceKey(family, viewportClass))
    return VALID_MODES.has(mode) ? mode : null
  } catch {
    return null
  }
}

export const writeViewPreference = ({ family, viewportClass, mode, storage }) => {
  if (!storage || !VALID_MODES.has(mode)) return false
  try {
    storage.setItem(getViewPreferenceKey(family, viewportClass), mode)
    return true
  } catch {
    return false
  }
}

export const resolveViewMode = ({ width, family, storage }) => {
  const viewportClass = getViewportClass(width)
  const storedMode = readViewPreference({ family, viewportClass, storage })
  if (storedMode) return storedMode
  return viewportClass === VIEWPORT_CLASS.MOBILE ? VIEW_MODE.CARDS : VIEW_MODE.TABLE
}

export const getTalentListFamily = ({ talentType, pathname = '' }) => {
  if (pathname === '/favorites' || pathname.startsWith('/favorites/')) return 'favorites'

  const families = {
    candidate: 'candidates',
    employee: 'employees',
    trainee: 'trainees',
    presale: 'presale',
    all: 'all-talents',
  }

  return families[talentType] || String(talentType || 'talents')
}
